import { render, staticRenderFns } from "./ParcelList.vue?vue&type=template&id=442df21c&"
import script from "./ParcelList.vue?vue&type=script&lang=js&"
export * from "./ParcelList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelList.vue?vue&type=style&index=0&id=442df21c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports